// extracted by mini-css-extract-plugin
export var filterIncDec = "_a9-0";
export var leftBorder = "_a9-1";
export var rightBorder = "_a9-2";
export var stringInput = "_a9-3";